module.exports = __webpack_public_path__ + "static/media/tech-cxo-community.dc5824ea.png";